import { useEffect } from "react";

/** Adds Escape-to-close on a modal. Pass the onClose handler. */
export function useEscapeKey(onClose) {
  useEffect(() => {
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose]);
}
